import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "@/data/site";

const links = [
  { id: "", label: "Home" },
  { id: "testimonials", label: "Testimonials" },
  { id: "about", label: "About" },
  { id: "works", label: "Works" },
  { id: "videos", label: "Videos" },
  { id: "socials", label: "Socials" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate(id ? `/#${id}` : "/");
      return;
    }
    if (!id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const linkClass =
    "text-sm tracking-wide text-steel hover:text-ink transition-colors duration-300";

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-xl border-b border-ink/10"
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <button
          onClick={() => go("")}
          data-testid="nav-logo"
          className="font-display text-xl md:text-2xl font-bold tracking-tight text-ink"
        >
          Nancy Naden
        </button>

        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => go(l.id)}
              className={linkClass}
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            data-testid="nav-hire-btn"
            className="rounded-full bg-terracotta text-ink font-medium px-5 py-2 text-sm transition-all duration-300 hover:bg-ink hover:text-cream"
          >
            Contact
          </button>
        </div>

        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-ink"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-cream border-t border-ink/10 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => go(l.id)}
              className={`${linkClass} text-left`}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            className="rounded-full bg-terracotta text-ink font-medium px-5 py-2 text-sm text-center"
          >
            Contact
          </button>
        </div>
      )}
    </header>
  );
};
